export default __webpack_public_path__ + "static/media/lightbulb.f53bae7a.jpg";